// module
import React from 'react';

class Footer extends React.Component{
    render(){
        return (
            <div className="footer">
                <small>
                1, Hallymdaehak-gil, Chuncheon-si, Gangwon-do 24252, Korea<br/>
                School of Software, Database Laboratory (1314)<br/>
                COPYRIGHT(C) 2019 HALLYM UNIV. DATABASE LAB. ALL RIGHTS RESERVED.<br/>
                </small>
            </div>
        );
    }
}

export default Footer;